import { IsBoolean, IsDefined } from 'class-validator';

export class ChatCustomPermissionsDto {
  @IsDefined()
  @IsBoolean()
  allowChatWithDifferentJobTitle: boolean;

  @IsDefined()
  @IsBoolean()
  allowChatWithDifferentMerchant: boolean;

  @IsDefined()
  @IsBoolean()
  allowChatWithDifferentCostCentre: boolean;

  @IsDefined()
  @IsBoolean()
  allowChatDirectMessages: boolean;

  constructor(data?: Partial<ChatCustomPermissionsDto>) {
    this.allowChatWithDifferentJobTitle = data?.allowChatWithDifferentJobTitle
      ? true
      : false;
    this.allowChatWithDifferentMerchant = data?.allowChatWithDifferentMerchant
      ? true
      : false;
    this.allowChatWithDifferentCostCentre =
      data?.allowChatWithDifferentCostCentre ? true : false;
    this.allowChatDirectMessages = data?.allowChatDirectMessages ? true : false;
  }

  default() {
    this.allowChatWithDifferentCostCentre = false;
    this.allowChatWithDifferentJobTitle = true;
    this.allowChatWithDifferentMerchant = false;
    this.allowChatDirectMessages = true;
  }

  getObject() {
    return {
      allowChatWithDifferentJobTitle: this.allowChatWithDifferentJobTitle,
      allowChatWithDifferentMerchant: this.allowChatWithDifferentMerchant,
      allowChatWithDifferentCostCentre: this.allowChatWithDifferentCostCentre,
      allowChatDirectMessages: this.allowChatDirectMessages
    };
  }
}
